import React, { useState, useEffect } from "react";
import usePopulateProposalItems from "./usePopulateProposalItems";
import tuluLogo from "../../images/carpenters/TULU logo.svg";
import styled from "styled-components/macro";
import Expand from "react-expand-animated";
import { SuggestedProductsForRent } from "../MyTulu/ExpendedMyTulu/SuggestedProductsForRent";
import addItemsCount from "../MyTulu/addSetItemsCount.jsx";
import { useNormalizeItems } from "../MyTulu/useNormalizeItems";
import Footer from "./CarpenterPdfFooter";
import { TuluRideExpended } from "../MyTulu/ExpendedMyTulu/TuluRideExpended";
import { TuluUnitDrawExpended } from "../MyTulu/ExpendedMyTulu/TuluUnitDrawExpended";
import { TuluUnitExpended } from "../MyTulu/PDF/TuluUnitExpended";
import wireSizes from "./WiresSizes.json";
import html2pdf from "html2pdf.js";

/**
 * @param {Object} props
 * @param {tulu.Item} props.data
 */

async function downloadCarpentryPDF() {
  const element = document.querySelector(".carpenterPdfRenderer");
  const opt = {
    margin: 1,
    filename: "Tulu Carpentery plan.pdf",
    image: { type: "jpeg", quality: 0.95 },
    html2canvas: {
      scale: 1,
      allowTaint: true,
      useCORS: true,
      truedpi: 300,
      letterRendering: true,
    },
    jsPDF: {
      unit: "px",
      format: [1230, 2000],
      orientation: "l",
    },
  };
  setTimeout(async () => {
    html2pdf().set(opt).from(element).save();
  }, 2);
}

export default function CarpenterView(proposal) {
  const [rentItems, setRentItems] = useState();
  const [shopItems, setShopItems] = useState();
  const [rideItems, setRideItems] = useState();
  const [itemsCount, setItemsCount] = useState({});
  const [location, setLocation] = useState("");
  const [rideColumnItems, setRideColumnItems] = useState();
  const [, setRideSimulationImage] = useState(null);
  const [, setRoomSimulationImage] = useState(null);
  const [, setLogoImage] = useState(null);
  const [colorUnit, setColorUnit] = useState();
  const [domLoaded, setDomLoaded] = useState(false);

  let theColumns = proposal?.data?.columns;
  useEffect(() => {
    setLocation(proposal?.data?.location);
    setRoomSimulationImage(proposal?.data?.roomSimulationImage);
    setRideSimulationImage(proposal?.data?.rideSimulationImage);
    setColorUnit(proposal?.data.colorUnit);
    setLogoImage(proposal?.data.logoImage);
    const newColumns = proposal?.data?.columns;
    const ride = proposal?.data?.rideItems;
    if (ride && ride.length > 0 && ride[0] && proposal.data.ride) {
      setRideColumnItems(ride);
    }
    if (theColumns && ride) {
      const addSetItemsCount = addItemsCount(setItemsCount);
      addSetItemsCount({ ride, newColumns });
    }
    // Mount-once: derives initial state from the proposal prop received once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const currentDate = new Date()
    .toLocaleDateString()
    .replace("/", "-")
    .replace("/", "-");

  let pageNumber = 0;
  const pageUp = () => {
    pageNumber++;
    return pageNumber;
  };
  const _renderExpendTitle = (
    bool,
    setBool,
    title,
    expend,
    showUpperDivider
  ) => {
    return (
      <>
        <div
          style={{
            fontSize: 40,
            fontWeight: 800,
            fontFamily: "Lexend",
            textTransform: "uppercase",
            flex: 1,
            marginLeft: 96,
          }}
        >
          {title}
        </div>
        <Expand open={bool}>{expend}</Expand>
        <div
          style={{
            margin: "0 100px",
          }}
        />
      </>
    );
  };

  useNormalizeItems(
    itemsCount,
    location,
    setShopItems,
    setRideItems,
    setRentItems
  );

  const [rentPages, setRentPages] = useState([]);
  const [purchasePages, setPurchasePages] = useState([]);

  usePopulateProposalItems(
    rentItems,
    rideItems,
    shopItems,
    setPurchasePages,
    setRentPages
  );

  const counts = {};
  const sizesArray = [];
  const allDistances = [];
  let distancesArrey;

  theColumns?.forEach((column, index) => {
    distancesArrey?.sort();
    distancesArrey?.pop();
    allDistances.push(distancesArrey);
    distancesArrey = [];
    let distance = 1;
    column.forEach((item, index) => {
      index === 0 && item && distancesArrey.push(1);
      item.showDoor && sizesArray.push(item.cellSize);
      distance = distance + item.cellSize;
      distancesArrey.push(distance);
    });
  });

  distancesArrey?.sort();
  distancesArrey &&
    distancesArrey[distancesArrey.length - 1] === 8 &&
    distancesArrey.pop();
  allDistances.push(distancesArrey);

  sizesArray.forEach((x) => {
    counts[x] = (counts[x] || 0) + 1;
  });
  let wiresArray = [];
  allDistances?.forEach((column, colNum) => {
    column?.forEach((row) => {
      wiresArray.push(wireSizes[colNum][row]);
    });
  });

  let wireCounts = {};
  wiresArray.forEach((x) => {
    wireCounts[x] = (wireCounts[x] || 0) + 1;
  });
  Object.entries(wireCounts).sort();

  let racksArray = [];
  proposal.data?.rideItems?.forEach((column) => {
    const type = column.type;
    const Items = column.items;
    const size = Items.length;
    const isSmall =
      (size < 3 && type === "bicycle") || (size < 4 && type === "scooter");
    isSmall && type === "bicycle" && racksArray.push("2 bikes rack");
    isSmall && type === "scooter" && racksArray.push("3 scooters rack");
    !isSmall && type === "bicycle" && racksArray.push("3 bikes rack");
    !isSmall && type === "scooter" && racksArray.push("4 scooters rack");
  });

  useEffect(() => {
    if (purchasePages.length>0) {
      return;
    }
    setDomLoaded(true);
  }, [purchasePages]);

  useEffect(() => {
    if (domLoaded)
   { downloadCarpentryPDF()}
  }, [domLoaded]);

  return (
    <div className="carpenterPdfRenderer">
      <PDFPage>
        {/* PDF1: coverPage */}
        <Img src={tuluLogo} />
        <SubHeader> Manufacturing instructions </SubHeader>
        <MainHeader>TULU UNIT @ {proposal?.data?.buildingName}</MainHeader>
        <div style={{ width: "947px" }}>
          <DetailLine>
            <Detail>Building's Address:</Detail>
            <Line width="100%" />
          </DetailLine>
          <DetailLine>
            <Detail>City:</Detail>
            <Line width="100%" />
          </DetailLine>
          <DetailLine>
            <Detail>Implementation Date:</Detail>
            <Line width="100%" />
          </DetailLine>
          <DetailLine>
            <Detail>Contact person:</Detail>
            <Line width="100%" />
          </DetailLine>
          <DetailLine>
            <Detail>Access details:</Detail>
            <Line width="100%" />
          </DetailLine>
          <DetailLine>
            <Detail>Additional comments:</Detail>
            <Line width="100%" />
          </DetailLine>
          <Line width="100%" />
        </div>
        <Pager>
          {<span style={{ marginRight: 10 }}>{currentDate}</span>} Page{" "}
          {pageUp()}
        </Pager>
      </PDFPage>
      {/* PDF2:Curation List -  Products For Rent */}
      {rentPages.map((page, index) => {
        return (
          <PDFPage>
            {_renderExpendTitle(
              true,
              null,
              "Curation List - Products For Rent",
              <SuggestedProductsForRent
                key={index}
                location={location}
                items={page}
                isPDF={true}
              />,
              false
            )}

            <Footer buildingName={proposal?.data?.buildingName} />
            <Pager>
              {<span style={{ marginRight: 10 }}>{currentDate}</span>} Page{" "}
              {pageUp()}
            </Pager>
          </PDFPage>
        );
      })}
      {/* PDF3:Curation List - Products For Purchase */}
      {purchasePages.map((page, index) => {
        const firstPage = index === 0;
        return (
          <PDFPage
            key={Object.keys(page)[0]}
            className="pdfPage"
            style={{ backgroundColor: "white" }}
          >
            {_renderExpendTitle(
              true,
              null,
              firstPage ? "Suggested Products For Purchase" : "",

              <SuggestedProductsForRent
                isShop={true}
                location={location}
                isPDF={true}
                items={page}
                setItems={setShopItems}
              />
            )}
            <Footer buildingName={proposal?.data?.buildingName} />
            <Pager>
              {<span style={{ marginRight: 10 }}>{currentDate}</span>} Page{" "}
              {pageUp()}
            </Pager>
          </PDFPage>
        );
      })}
      {/* PDF4: Unit Rendering  */}
      {theColumns && itemsCount && (
        <>
          <PDFPage className="pdfPage">
            <SubHeader style={{ marginLeft: "85px" }}>UNIT RENDERING</SubHeader>
            <ExpendedWrapper style={{ marginLeft: "-315px" }}>
              <TuluUnitExpended
                colorUnit={colorUnit}
                columns={proposal?.data?.columns}
                itemsCount={itemsCount}
                headLine={""}
                isCarpenter={true}
              />
            </ExpendedWrapper>
            <DetailsDiv>
              <h3>DETAILS</h3>
              <p>Columns: {theColumns?.length}</p>
              <p>
                Top part:{" "}
                {theColumns.length === 2 ||
                theColumns.length === 3 ||
                theColumns.length === 4
                  ? "one piece"
                  : "2 pieces"}
              </p>
              <p>
                Bottom part:{" "}
                {theColumns.length === 2 ||
                theColumns.length === 3 ||
                theColumns.length === 4
                  ? "one piece"
                  : "2 pieces"}
              </p>
              <br />
              <h3>COMMENTS</h3>
              <p>
                * In the Shop cells, the internal shelves are shorter. <br />
                * “TULU” logo is centerd to the monitor.
                <br />* please make 2 holes in the top of the monitor cell 3
                inch each (for cables)
              </p>
            </DetailsDiv>
            <Footer buildingName={proposal?.data?.buildingName} />
            <Pager>
              {<span style={{ marginRight: 10 }}>{currentDate}</span>} Page{" "}
              {pageUp()}
            </Pager>
          </PDFPage>
          {/* PDF5: A Drow of UNIT RENDERING */}
          <PDFPage className="pdfPage">
            <SubHeader style={{ marginLeft: "85px" }}>DOORS LAYOUT</SubHeader>
            <ExpendedWrapper
              style={{ marginLeft: "300px", transform: "scale(1.25) " }}
            >
              <TuluUnitDrawExpended
                isPDF={false}
                isCarpenter={true}
                isWires={false}
                colorUnit={colorUnit}
                rideItems={rideColumnItems}
                logoImage={null}
                columns={theColumns}
                itemsCount={itemsCount}
                location={location}
                isSticker={false}
              />
            </ExpendedWrapper>
            {counts !== {} && (
              <DetailsDiv>
                <h3>DOORS</h3>
                <p>Size 1: {counts[1] ? counts[1] : 0}</p>
                <p>Size 2: {counts[2] ? counts[2] : 0}</p>
                <p>Size 3: {counts[3] ? counts[3] : 0}</p>
                <p>Size 4: {counts[4] ? counts[4] : 0}</p>
                <p>Size 5: {counts[5] ? counts[5] : 0}</p>
                <p>Size 6: {counts[6] ? counts[6] : 0}</p>
                <p>Size 7: {counts[7] ? counts[7] : 0}</p>
                <h3>COMMENTS</h3>
                <p>
                  * Doors from size 3 and more have side channels to make them
                  stronger. <br />
                  <br />* For expensive items we will build a metal frame that
                  will make the extra protection.
                </p>
              </DetailsDiv>
            )}

            <Footer buildingName={proposal?.data?.buildingName} />
            <Pager>
              {<span style={{ marginRight: 10 }}>{currentDate}</span>} Page{" "}
              {pageUp()}
            </Pager>
          </PDFPage>

          {/* PDF6: Wires */}
          <PDFPage className="pdfPage">
            <SubHeader style={{ marginLeft: "85px" }}>
              ELECTRIC CABELS HOLES
            </SubHeader>
            <ExpendedWrapper
              style={{ marginLeft: "300px", transform: "scale(1.25) " }}
            >
              <TuluUnitDrawExpended
                isPDF={false}
                isElectric={true}
                electricHall={1}
                isSticker={false}
                isWires={true}
                isCarpenter={true}
                colorUnit={colorUnit}
                rideItems={rideColumnItems}
                logoImage={null}
                columns={theColumns}
                itemsCount={itemsCount}
                location={location}
              />
            </ExpendedWrapper>

            <DetailsDiv>
              <h3>ELECTRIC HOLES</h3>
              <p style={{ fontSize: "20px" }}>
                Electric Holes 1. Monitor cable + Brain:
                <br />
                Size: Hole 3” Location: In the Top shelf, 2 holes in <br />
                back of the shelf
                <br />
                <br />
                2. Standard Electric Cable
                <br />
                Size: 1”
                <br />
                location: 1.5” from right panel, 1.5 above the shelf
                <br />
                <br />
                3. Double Standard Electric Cable
                <br />
                Size: 1”
                <br />
                location: 1.5” from right/left panel, 1.5 above the shelf
                <br />
                <br />
                4. Vacuum cleaner power
                <br />
                Size: 1”
                <br />
                location: 5 inch from the side, and 15 inch
                <br />
                from the bottom of the shelf. <br />
                <br />
                5. Printer power
                <br />
                Size: 2”
                <br />
                location: in the middle of the column, 1.5 above the shelf
                <br />
                <br />
                6. Fridge hole: <br />
                Size: 2”
                <br />
                location: 3 inch from <br />
                the top, and 3.5 inch from <br />
                each other.
                <br />
              </p>
            </DetailsDiv>

            <Footer buildingName={proposal?.data?.buildingName} />
            <Pager>
              {<span style={{ marginRight: 10 }}>{currentDate}</span>} Page{" "}
              {pageUp()}
            </Pager>
          </PDFPage>

          {/* PDF7: Wires */}
          <PDFPage className="pdfPage">
            <SubHeader style={{ marginLeft: "85px" }}>WIRES LAYOUT</SubHeader>
            <ExpendedWrapper
              style={{ marginLeft: "300px", transform: "scale(1.25) " }}
            >
              <TuluUnitDrawExpended
                isPDF={false}
                isSticker={false}
                isWires={true}
                isCarpenter={true}
                colorUnit={colorUnit}
                rideItems={rideColumnItems}
                logoImage={null}
                columns={theColumns}
                itemsCount={itemsCount}
                location={location}
              />
            </ExpendedWrapper>

            <DetailsDiv>
              <h3>ELECTRIC CABLES LENGHT</h3>
              <table>
                <thead>
                  <tr>
                    <th>Lenth</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(wireCounts)
                    .sort()
                    .map((x) => {
                      return (
                        <tr>
                          <td>{x[0]} Meters</td>
                          <td>{x[1]} </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </DetailsDiv>

            <Footer buildingName={proposal?.data?.buildingName} />
            <Pager>
              {<span style={{ marginRight: 10 }}>{currentDate}</span>} Page{" "}
              {pageUp()}
            </Pager>
          </PDFPage>

          {/* PDF8: Stickers */}
          <PDFPage className="pdfPage">
            <SubHeader style={{ marginLeft: "85px" }}>STICKERS</SubHeader>
            <ExpendedWrapper
              style={{ marginLeft: "300px", transform: "scale(1.25) " }}
            >
              <TuluUnitDrawExpended
                isPDF={false}
                isSticker={true}
                isCarpenter={true}
                colorUnit={colorUnit}
                rideItems={rideColumnItems}
                logoImage={null}
                isWires={false}
                columns={theColumns}
                itemsCount={itemsCount}
                location={location}
              />
            </ExpendedWrapper>
            {counts !== {} && (
              <DetailsDiv>
                <h3>STICKERS</h3>
                <p>Stickers colors:</p>
                <p>Clean: Pink</p>
                <p>Play: Green </p>
                <p>DIY: Red </p>
                <p>Cook: Orange</p>
                <p>Print: Blue</p>
                <p>Host: dark Pink</p>
                <p>Fitness Light Blue</p>
                <p>Outdoor: Dark Green</p>
                <p>Shop: Yellow</p>
              </DetailsDiv>
            )}

            <Footer buildingName={proposal?.data?.buildingName} />
            <Pager>
              {<span style={{ marginRight: 10 }}>{currentDate}</span>} Page{" "}
              {pageUp()}
            </Pager>
          </PDFPage>

          {rideColumnItems && (
            <PDFPage className="pdfPage">
              <SubHeader style={{ marginLeft: "85px" }}>TULU RIDE</SubHeader>
              <ExpendedWrapper
                style={{ marginLeft: "-510px", transform: "scale(0.75) " }}
              >
                <TuluRideExpended
                  isCarpenter={true}
                  isPDF={true}
                  colorUnit={colorUnit}
                  rideColumnItems={rideColumnItems}
                  itemsCount={itemsCount}
                />
              </ExpendedWrapper>
              <DetailsDiv>
                <h3>TULU RIDE</h3>
                <p>Items:</p>
                <p>Scooters: {rideItems?.Scooter?.count || 0}</p>
                <p>Bikes: {rideItems?.Bicycle?.count || 0} </p>
                <p>
                  Ebikes:{" "}
                  {(rideItems && rideItems["Electric Bikes"]?.count) || 0}{" "}
                </p>
                <br />
                <p>Racks:</p>
                <p>
                  3 Scooters rack:{" "}
                  {racksArray.filter((x) => x === "3 scooters rack").length}
                </p>
                <p>
                  4 Scooters rack:{" "}
                  {racksArray.filter((x) => x === "4 scooters rack").length}
                </p>
                <p>
                  2 bikes rack:{" "}
                  {racksArray.filter((x) => x === "2 bikes rack").length}{" "}
                </p>
                <p>
                  3 bikes rack:{" "}
                  {racksArray.filter((x) => x === "3 bikes rack").length}
                </p>
              </DetailsDiv>
              <Footer buildingName={proposal?.data?.buildingName} />
              <Pager>
                {<span style={{ marginRight: 10 }}>{currentDate}</span>} Page{" "}
                {pageUp()}
              </Pager>
            </PDFPage>
          )}
        </>
      )}
    </div>
  );
}

const PDFPage = styled.div`
  font-family: "Lexend", serif;
  margin-left: 105px;
  height: 1230px;
  width: 1920px;
  padding-top: 127px;
  position: relative;
`;
const SubHeader = styled.div`
  font-family: "Lexend", serif;
  font-size: 40px;
  font-weight: bold;
  line-height: 2.13;
  text-align: left;
`;
const MainHeader = styled.div`
  font-family: "Lexend", serif;
  font-size: 55px;
  font-weight: bold;
  line-height: 1.55;
  text-align: left;
  margin-bottom: 50px;
`;
const Img = styled.img`
  width: 269px;
  margin-bottom: 69px;
`;

const DetailLine = styled.div`
  display: flex;
  align-items: center;
`;
const Detail = styled.p`
  font-family: "DMSans", serif;
  font-size: 28px;
  font-weight: 500;
  line-height: 2.14;
  white-space: nowrap;
  margin-bottom: 0;
`;
const Line = styled.hr`
  width: ${(props) => props.width};
  height: 1px;
  color: black;
  margin-top: 40px;
`;
const Pager = styled.div`
  position: absolute;
  bottom: 50px;
  right: 100px;
  font-size: 22px;
`;

const ExpendedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;
const DetailsDiv = styled.div`
  position: absolute;
  padding: 47.5px;
  top: 157px;
  bottom: 160px;
  right: 100px;
  width: 466px;
  font-family: DMSans, serif;
  border: solid black 1px;
  font-size: 22px;
`;
